import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import i18n from "src/i18n";
import { ImportModeCard } from "../import-mode-card";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import BlockIcon from "@mui/icons-material/Block";
import MenuBookIcon from "@mui/icons-material/MenuBook";

type ProductionImportModalProps = {
  open: boolean;
  handleClose: () => void;
  isPending: boolean;
  onConfirm: (withRecipe: boolean) => void;
};

export const ProductionImportModal = ({
  open,
  handleClose,
  isPending,
  onConfirm,
}: ProductionImportModalProps) => {
  const { t } = useTranslation("integrations");
  const { t: generalT } = useTranslation("general");
  const [withRecipe, setWithRecipe] = useState(true);
  const isArabic = i18n.language === "ar";

  const onClose = () => {
    if (isPending) return;
    setWithRecipe(true);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography fontSize={18} fontWeight={600} color="#101828">
          {t("foodicsWorkspace.productionImport.modeQuestion")}
        </Typography>
        <Typography fontSize={14} color="#667085">
          {t("foodicsWorkspace.productionImport.modeHint")}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1}>
          <ImportModeCard
            icon={<MenuBookIcon fontSize="small" />}
            iconBgcolor="#FF8D3F"
            iconColor="#FFFFFF"
            title={t("foodicsWorkspace.productionImport.withRecipeTitle")}
            subtitle={t("foodicsWorkspace.productionImport.withRecipeSubtitle")}
            isSelected={withRecipe}
            onSelect={() => setWithRecipe(true)}
          />
          <ImportModeCard
            icon={<BlockIcon fontSize="small" />}
            iconBgcolor="#F2F4F7"
            iconColor="#667085"
            title={t("foodicsWorkspace.productionImport.withoutRecipeTitle")}
            subtitle={t(
              "foodicsWorkspace.productionImport.withoutRecipeSubtitle"
            )}
            isSelected={!withRecipe}
            onSelect={() => setWithRecipe(false)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isPending}>
          {generalT("cancel")}
        </Button>
        <Button
          variant="contained"
          disabled={isPending}
          endIcon={
            isPending ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <ArrowForwardIcon
                sx={{ transform: isArabic ? "scaleX(-1)" : "none" }}
                fontSize="small"
              />
            )
          }
          onClick={() => onConfirm(withRecipe)}
        >
          {t("foodicsWorkspace.importProduction")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
